import { render } from "./MarketingDatatableTDSentError.vue?vue&type=template&id=20078613"
import script from "./MarketingDatatableTDSentError.vue?vue&type=script&lang=js"
export * from "./MarketingDatatableTDSentError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__